import {
  r
} from "./chunk.XVPEWHDV.js";

// src/styles/component.styles.ts
var component_styles_default = r`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }
`;

export {
  component_styles_default
};
